var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-shipment-option"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-8"
  }, [_c('span', {
    staticClass: "input-group-text btn btn-sm btn-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeStatus),
      expression: "changeStatus"
    }],
    staticClass: "custom-radio",
    attrs: {
      "type": "radio",
      "id": "single",
      "name": "RTODetails"
    },
    domProps: {
      "value": _vm.RTODetails,
      "checked": _vm._q(_vm.changeStatus, _vm.RTODetails)
    },
    on: {
      "click": function($event) {
        return _vm.clearAll()
      },
      "change": function($event) {
        _vm.changeStatus = _vm.RTODetails
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(" Update RTO Details ")])]), _vm._v("   \n                      "), _c('span', {
    staticClass: "input-group-text btn btn-sm btn-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeStatus),
      expression: "changeStatus"
    }],
    staticClass: "custom-radio",
    attrs: {
      "type": "radio",
      "id": "ShipmentDetails",
      "name": "ShipmentDetails"
    },
    domProps: {
      "value": _vm.ShipmentDetails,
      "checked": _vm._q(_vm.changeStatus, _vm.ShipmentDetails)
    },
    on: {
      "click": _vm.clearAll,
      "change": function($event) {
        _vm.changeStatus = _vm.ShipmentDetails
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(" Update Shipment Details ")])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus === 0),
      expression: "changeStatus===0"
    }],
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-shipment-option"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-form-fieldset', [_vm._v(" \n                "), _c('label', [_vm._v("Select Type RTO/DTO")]), _vm._v("\n                    \n                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rtodto),
      expression: "rtodto"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "name": "rtodto",
      "id": "rtodto"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rtodto = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a Shipment Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("RTO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("DTO")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rtodto')),
      expression: "errors.has('rtodto')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The RTO/DTO Type field is required.")])])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus === 0),
      expression: "changeStatus===0"
    }],
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-shipment-option"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-8"
  }, [_c('span', {
    staticClass: "input-group-text btn btn-sm btn-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeShipmentStatusflagrtodto),
      expression: "changeShipmentStatusflagrtodto"
    }],
    attrs: {
      "type": "radio",
      "id": "singleShipmentrtodto",
      "name": "singleShipmentrtodto"
    },
    domProps: {
      "value": _vm.singleShipmentrtodto,
      "checked": _vm._q(_vm.changeShipmentStatusflagrtodto, _vm.singleShipmentrtodto)
    },
    on: {
      "change": function($event) {
        _vm.changeShipmentStatusflagrtodto = _vm.singleShipmentrtodto
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(" Update Address using ShippingID ")])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-text btn btn-sm btn-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeShipmentStatusflagrtodto),
      expression: "changeShipmentStatusflagrtodto"
    }],
    attrs: {
      "type": "radio",
      "id": "bulkShipmentrtodto",
      "name": "bulkShipmentrtodto"
    },
    domProps: {
      "value": _vm.bulkShipmentrtodto,
      "checked": _vm._q(_vm.changeShipmentStatusflagrtodto, _vm.bulkShipmentrtodto)
    },
    on: {
      "change": function($event) {
        _vm.changeShipmentStatusflagrtodto = _vm.bulkShipmentrtodto
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(" Update Address in Bulk ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeShipmentStatusflagrtodto === 0 && _vm.changeStatus === 0),
      expression: "changeShipmentStatusflagrtodto === 0 && changeStatus===0"
    }],
    staticClass: "card"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtShipmentId),
      expression: "txtShipmentId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('txtShipmentId')
    },
    attrs: {
      "id": "txtShipmentId",
      "type": "text",
      "name": "txtShipmentId",
      "placeholder": "Enter Shipment Id"
    },
    domProps: {
      "value": (_vm.txtShipmentId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtShipmentId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.txtShipmentId')),
      expression: "errors.has('form-1.txtShipmentId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Shipment Id.")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit",
      "value": _vm.shipmetsflagforshow
    },
    model: {
      value: (_vm.buttonflag),
      callback: function($$v) {
        _vm.buttonflag = $$v
      },
      expression: "buttonflag"
    }
  }, [_vm._v(" Show")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Reset")])])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 input-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeShipmentStatusflagrtodto === 0 && _vm.changeStatus === 0 && _vm.shippingDetailsShow == true),
      expression: "changeShipmentStatusflagrtodto === 0 && changeStatus===0 && shippingDetailsShow == true"
    }],
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.PrevRTODetails.Shippingid))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.PrevRTODetails.RTOName))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.PrevRTODetails.RTOAddress))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.PrevRTODetails.RTOState))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.PrevRTODetails.RTOCity))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.PrevRTODetails.RTOPincode))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.PrevRTODetails.RTOMobileNo) + " ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.PrevRTODetails.Status))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.PrevRTODetails.ShipmentStatus))])])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeShipmentStatusflagrtodto === 0 && _vm.changeStatus === 0 && _vm.shippingRTODetailsShow == true),
      expression: "changeShipmentStatusflagrtodto === 0 && changeStatus===0 && shippingRTODetailsShow == true"
    }],
    staticClass: "col-md-6"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm2('form-2')
      }
    }
  }, [_c('div', {
    staticClass: "card card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-6"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CopyAddressCheck),
      expression: "CopyAddressCheck"
    }],
    attrs: {
      "type": "checkbox",
      "name": "CopyAddress",
      "id": "CopyAddressCheck"
    },
    domProps: {
      "checked": Array.isArray(_vm.CopyAddressCheck) ? _vm._i(_vm.CopyAddressCheck, null) > -1 : (_vm.CopyAddressCheck)
    },
    on: {
      "click": function($event) {
        return _vm.checkAddres($event)
      },
      "change": function($event) {
        var $$a = _vm.CopyAddressCheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.CopyAddressCheck = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.CopyAddressCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.CopyAddressCheck = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Copy Address Details")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewRTODetails.newRTOName),
      expression: "NewRTODetails.newRTOName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('newRTOName')
    },
    attrs: {
      "id": "newRTOName",
      "type": "text",
      "name": "newRTOName",
      "placeholder": "Enter new RTO name "
    },
    domProps: {
      "value": (_vm.NewRTODetails.newRTOName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewRTODetails, "newRTOName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.newRTOName')),
      expression: "errors.has('form-2.newRTOName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter RTO name.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewRTODetails.NewRTOAddress),
      expression: "NewRTODetails.NewRTOAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "textarea",
    class: {
      'form-control': true,
      'error': _vm.errors.has('NewRTOAddress')
    },
    attrs: {
      "rows": "2",
      "name": "NewRTOAddress",
      "id": "NewRTOAddress"
    },
    domProps: {
      "value": (_vm.NewRTODetails.NewRTOAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewRTODetails, "NewRTOAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.NewRTOAddress')),
      expression: "errors.has('form-2.NewRTOAddress')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter new address.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.NewRTODetails.newRTOState),
      expression: "NewRTODetails.newRTOState"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('newRTOState')
    },
    attrs: {
      "id": "newRTOState",
      "name": "newRTOState"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.NewRTODetails, "newRTOState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getCity]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select State--")]), _vm._v(" "), _vm._l((_vm.newRTOStateObj), function(state_obj) {
    return _c('option', {
      domProps: {
        "value": state_obj.stateid
      }
    }, [_vm._v(_vm._s(state_obj.statename))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.newRTOState')),
      expression: "errors.has('form-2.newRTOState')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select state.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.NewRTODetails.newRTOCity),
      expression: "NewRTODetails.newRTOCity"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('newRTOState')
    },
    attrs: {
      "id": "newRTOCity",
      "name": "newRTOCity"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.NewRTODetails, "newRTOCity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select city--")]), _vm._v(" "), _vm._l((_vm.newRTOCityObj), function(city_obj) {
    return _c('option', {
      domProps: {
        "value": city_obj.cityid
      }
    }, [_vm._v(_vm._s(city_obj.cityname))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.newRTOCity')),
      expression: "errors.has('form-2.newRTOCity')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select city.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewRTODetails.NewRTOPincode),
      expression: "NewRTODetails.NewRTOPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('NewRTOPincode')
    },
    attrs: {
      "id": "NewRTOPincode",
      "type": "text",
      "name": "NewRTOPincode",
      "placeholder": "Please Enter Pincode",
      "minlength": "6",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.NewRTODetails.NewRTOPincode)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewRTODetails, "NewRTOPincode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.NewRTOPincode')),
      expression: "errors.has('form-2.NewRTOPincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Pincode")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(16), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewRTODetails.NewRTOmobileno),
      expression: "NewRTODetails.NewRTOmobileno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('NewRTOmobileno')
    },
    attrs: {
      "id": "NewRTOmobileno",
      "type": "text",
      "name": "NewRTOmobileno",
      "placeholder": "Please Enter mobile no",
      "minlength": "10",
      "maxlength": "12"
    },
    domProps: {
      "value": (_vm.NewRTODetails.NewRTOmobileno)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewRTODetails, "NewRTOmobileno", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.NewRTOmobileno')),
      expression: "errors.has('form-2.NewRTOmobileno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter mobile no")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(17), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.NewRTODetails.NewRTOReason),
      expression: "NewRTODetails.NewRTOReason"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('NewRTOReason')
    },
    attrs: {
      "id": "NewRTOReason",
      "name": "NewRTOReason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.NewRTODetails, "NewRTOReason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select reason--")]), _vm._v(" "), _vm._l((_vm.reasonObj), function(Reason_obj) {
    return _c('option', {
      domProps: {
        "value": Reason_obj.ReasonsID
      }
    }, [_vm._v(_vm._s(Reason_obj.Reason))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.NewRTOReason')),
      expression: "errors.has('form-2.NewRTOReason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Reason.")])], 1)]), _vm._v(" "), _vm._m(18)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeShipmentStatusflagrtodto === 0 && _vm.changeStatus === 0 && _vm.shippingRTODetailsChangeHubShow == true),
      expression: "changeShipmentStatusflagrtodto === 0 && changeStatus===0 && shippingRTODetailsChangeHubShow == true"
    }],
    staticClass: "col-md-6"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-5"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm5('form-5')
      }
    }
  }, [_c('div', {
    staticClass: "card card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(19), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-7"
  }, [_c('label', [_vm._v(_vm._s(_vm.CurrentRTODetails.RTOTOName))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(20), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.CurrentRTODetails.changeRTOTOHubId),
      expression: "CurrentRTODetails.changeRTOTOHubId"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('changeRTOTOHubId')
    },
    attrs: {
      "id": "changeRTOTOHubId",
      "name": "changeRTOTOHubId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.CurrentRTODetails, "changeRTOTOHubId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select hub--")]), _vm._v(" "), _vm._l((_vm.changeRTOTOHubIdObj), function(changeRTOTOHubId_obj) {
    return _c('option', {
      domProps: {
        "value": changeRTOTOHubId_obj.HubID
      }
    }, [_vm._v(_vm._s(changeRTOTOHubId_obj.HubName))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-5.changeRTOTOHubId')),
      expression: "errors.has('form-5.changeRTOTOHubId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select hub.")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(21), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.CurrentRTODetails.RTOReason),
      expression: "CurrentRTODetails.RTOReason"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('RTOReason')
    },
    attrs: {
      "id": "RTOReason",
      "name": "RTOReason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.CurrentRTODetails, "RTOReason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select reason--")]), _vm._v(" "), _vm._l((_vm.reasonObj), function(Reason_obj) {
    return _c('option', {
      domProps: {
        "value": Reason_obj.ReasonsID
      }
    }, [_vm._v(_vm._s(Reason_obj.Reason))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-5.RTOReason')),
      expression: "errors.has('form-5.RTOReason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Reason.")])], 1)]), _vm._v(" "), _vm._m(22)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeShipmentStatusflagrtodto === 1 && _vm.changeStatus === 0),
      expression: "changeShipmentStatusflagrtodto === 1 && changeStatus===0"
    }],
    staticClass: "card"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-7"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateFormRTOupload('form-7')
      }
    }
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(24), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "fileupload",
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('FileUploadRTO')
    },
    attrs: {
      "id": "FileUploadRTO",
      "type": "file",
      "name": "FileUploadRTO",
      "accept": ".csv"
    },
    on: {
      "change": _vm.getUploadEvent
    }
  })]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticClass: "sample-format",
    on: {
      "click": _vm.downloadCSV
    }
  }, [_vm._v("Download sample file format")])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-7.FileUploadRTO')),
      expression: "errors.has('form-7.FileUploadRTO')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "csvwmsgRTO"
    }
  }, [_vm._v("Please choose file.")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._m(25), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger",
    on: {
      "click": _vm.clearFile
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("Reset")]), _vm._v(" "), _vm._l((_vm.groupedErrors), function(items) {
    return [(items.code == 200) ? _c('div', [_c('label', {
      staticStyle: {
        "color": "green",
        "margin-top": "5px"
      }
    }, [_vm._v("Shipping Id :  " + _vm._s(items.data) + " : " + _vm._s(items.message) + " ")])]) : _c('div', [_c('label', {
      staticStyle: {
        "color": "red",
        "margin-top": "5px"
      }
    }, [_vm._v(_vm._s(items.data) + " :  " + _vm._s(items.message) + " ")])])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus === 1),
      expression: "changeStatus===1"
    }],
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-shipment-option"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-8"
  }, [_c('span', {
    staticClass: "input-group-text btn btn-sm btn-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeShipmentStatusflag),
      expression: "changeShipmentStatusflag"
    }],
    attrs: {
      "type": "radio",
      "id": "singleShipment",
      "name": "singleShipment"
    },
    domProps: {
      "value": _vm.singleShipment,
      "checked": _vm._q(_vm.changeShipmentStatusflag, _vm.singleShipment)
    },
    on: {
      "change": function($event) {
        _vm.changeShipmentStatusflag = _vm.singleShipment
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(" Update Address using ShippingID ")])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-text btn btn-sm btn-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeShipmentStatusflag),
      expression: "changeShipmentStatusflag"
    }],
    attrs: {
      "type": "radio",
      "id": "bulkShipment",
      "name": "bulkShipment"
    },
    domProps: {
      "value": _vm.bulkShipment,
      "checked": _vm._q(_vm.changeShipmentStatusflag, _vm.bulkShipment)
    },
    on: {
      "change": function($event) {
        _vm.changeShipmentStatusflag = _vm.bulkShipment
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(" Update Address in Bulk ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeShipmentStatusflag === 0 && _vm.changeStatus === 1),
      expression: "changeShipmentStatusflag === 0 && changeStatus===1"
    }],
    staticClass: "card"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-3"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm3('form-3')
      }
    }
  }, [_vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(27), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtShipmentId),
      expression: "txtShipmentId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('txtShipmentId')
    },
    attrs: {
      "id": "txtShipmentId",
      "type": "text",
      "name": "txtShipmentId",
      "placeholder": "Enter Shipment Id"
    },
    domProps: {
      "value": (_vm.txtShipmentId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtShipmentId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.txtShipmentId')),
      expression: "errors.has('form-3.txtShipmentId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Shipment Id.")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    },
    model: {
      value: (_vm.buttonflag1),
      callback: function($$v) {
        _vm.buttonflag1 = $$v
      },
      expression: "buttonflag1"
    }
  }, [_vm._v(" Show")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    on: {
      "click": _vm.clear
    }
  }, [_vm._v(" Reset")])])], 1)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeShipmentStatusflag === 0 && _vm.changeStatus === 1 && _vm.shippingDetailsShow1 == true),
      expression: "changeShipmentStatusflag === 0 && changeStatus===1 && shippingDetailsShow1 == true"
    }],
    staticClass: "shipments-details-shows"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-4"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm4('form-4')
      }
    }
  }, [_c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(28), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipDetails.shippingAddress),
      expression: "shipDetails.shippingAddress"
    }],
    ref: "textarea",
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "name": "shippingAddress",
      "id": "shippingAddress"
    },
    domProps: {
      "value": (_vm.shipDetails.shippingAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipDetails, "shippingAddress", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(29), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.shipDetails.ShippingState),
      expression: "shipDetails.ShippingState"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShippingState')
    },
    attrs: {
      "id": "ShippingState",
      "name": "ShippingState"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.shipDetails, "ShippingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getCity]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select State--")]), _vm._v(" "), _vm._l((_vm.newRTOStateObj), function(state_obj) {
    return _c('option', {
      domProps: {
        "value": state_obj.stateid
      }
    }, [_vm._v(_vm._s(state_obj.statename))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-4.ShippingState')),
      expression: "errors.has('form-4.ShippingState')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select state.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(30), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.shipDetails.ShippingCity),
      expression: "shipDetails.ShippingCity"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShippingCity')
    },
    attrs: {
      "id": "ShippingCity",
      "name": "ShippingCity"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.shipDetails, "ShippingCity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select city--")]), _vm._v(" "), _vm._l((_vm.newRTOCityObj), function(city_obj) {
    return _c('option', {
      domProps: {
        "value": city_obj.cityid
      }
    }, [_vm._v(_vm._s(city_obj.cityname))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-4.ShippingCity')),
      expression: "errors.has('form-4.ShippingCity')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select city.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(31), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipDetails.mobileno),
      expression: "shipDetails.mobileno"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('mobileno')
    },
    attrs: {
      "id": "mobileno",
      "type": "text",
      "name": "mobileno",
      "placeholder": "Please Enter mobile no",
      "minlength": "10",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.shipDetails.mobileno)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipDetails, "mobileno", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-4.mobileno')),
      expression: "errors.has('form-4.mobileno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter mobile no")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(32), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipDetails.ShippingPincode),
      expression: "shipDetails.ShippingPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShippingPincode')
    },
    attrs: {
      "id": "ShippingPincode",
      "type": "text",
      "name": "ShippingPincode",
      "placeholder": "Please Enter Pincode",
      "minlength": "6",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.shipDetails.ShippingPincode)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipDetails, "ShippingPincode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-4.ShippingPincode')),
      expression: "errors.has('form-4.ShippingPincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Pincode")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(33), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rblBulkIsRedirect1),
      expression: "rblBulkIsRedirect1"
    }],
    staticClass: "IsRedirected-bank",
    attrs: {
      "type": "radio",
      "id": "rblBulkIsRedirect_1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.rblBulkIsRedirect1, "1")
    },
    on: {
      "change": function($event) {
        _vm.rblBulkIsRedirect1 = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rblBulkIsRedirect_1"
    }
  }, [_vm._v(" Yes ")]), _vm._v("  \n                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rblBulkIsRedirect1),
      expression: "rblBulkIsRedirect1"
    }],
    staticClass: "IsRedirected-bank",
    attrs: {
      "type": "radio",
      "id": "rblBulkIsRedirect_0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.rblBulkIsRedirect1, "0")
    },
    on: {
      "change": function($event) {
        _vm.rblBulkIsRedirect1 = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rblBulkIsRedirect_0"
    }
  }, [_vm._v("No ")])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rblBulkIsRedirect1 == 1),
      expression: "rblBulkIsRedirect1==1"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(34), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipDetails.SolID),
      expression: "shipDetails.SolID"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "SolID",
      "type": "text",
      "name": "SolID",
      "placeholder": "Please Enter solid"
    },
    domProps: {
      "value": (_vm.shipDetails.SolID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipDetails, "SolID", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-4.SolID')),
      expression: "errors.has('form-4.SolID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Sol ID")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(35), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.shipDetails.ShippingComments),
      expression: "shipDetails.ShippingComments"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('RTOReason')
    },
    attrs: {
      "id": "ShippingComments",
      "name": "ShippingComments"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.shipDetails, "ShippingComments", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select reason--")]), _vm._v(" "), _vm._l((_vm.reasonObj), function(Reason_obj) {
    return _c('option', {
      domProps: {
        "value": Reason_obj.ReasonsID
      }
    }, [_vm._v(_vm._s(Reason_obj.Reason))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-4.ShippingComments')),
      expression: "errors.has('form-4.ShippingComments')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Reason.")])], 1)]), _vm._v(" "), _vm._m(36)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeShipmentStatusflag === 1 && _vm.changeStatus === 1),
      expression: "changeShipmentStatusflag === 1 && changeStatus===1"
    }],
    staticClass: "card"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-6"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm1('form-6')
      }
    }
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(38), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-9"
  }, [_c('span', {
    staticClass: "input-group-text IsRedirected-bank"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rblBulkIsRedirect),
      expression: "rblBulkIsRedirect"
    }],
    attrs: {
      "type": "radio",
      "id": "rblBulkIsRedirect_1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.rblBulkIsRedirect, "1")
    },
    on: {
      "change": function($event) {
        _vm.rblBulkIsRedirect = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rblBulkIsRedirect_1"
    }
  }, [_vm._v(" Yes ")])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-text IsRedirected-bank"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rblBulkIsRedirect),
      expression: "rblBulkIsRedirect"
    }],
    attrs: {
      "type": "radio",
      "id": "rblBulkIsRedirect_0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.rblBulkIsRedirect, "0")
    },
    on: {
      "change": function($event) {
        _vm.rblBulkIsRedirect = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rblBulkIsRedirect_0"
    }
  }, [_vm._v("No ")])]), _vm._v(" "), _c('span', {
    staticClass: "sample-format",
    on: {
      "click": _vm.downloadCSV
    }
  }, [_vm._v("Download sample file format")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-6.rblBulkIsRedirect')),
      expression: "errors.has('form-6.rblBulkIsRedirect')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter txtShipmentId.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(39), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "fileupload1",
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('FileUpload1')
    },
    attrs: {
      "id": "FileUpload1",
      "type": "file",
      "name": "FileUpload1",
      "accept": ".csv"
    },
    on: {
      "change": _vm.getUploadEvent
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-6.FileUpload1')),
      expression: "errors.has('form-6.FileUpload1')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "csvwmsgtxt"
    }
  }, [_vm._v("Please choose file.")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._m(40), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger",
    on: {
      "click": _vm.clearFile
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    on: {
      "click": _vm.clear
    }
  }), _vm._v("Reset")]), _vm._v(" "), _vm._l((_vm.groupedErrors), function(items) {
    return [(items.code == 200) ? _c('div', [_c('label', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v("Shipping Id :  " + _vm._s(items.data) + " : " + _vm._s(items.message) + " ")])]) : _c('div', [_c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(items.data) + " :  " + _vm._s(items.message) + " ")])])]
  })], 2)])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Update Address Using ShippingID")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Shipment ID : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Shipping Id\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Prev RTOToName\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Prev RTOAddress\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Prev RTOState\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Prev RTOCity\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Prev RTOPincode\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Prev RTOMobileNo\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Status\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Shipment Status\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      New RTOToName\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      New RTOAddress\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      New RTOState\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      New RTOCity\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      New RTOPincode\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      New RTOMobileNo\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Reason\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Change RTO Details ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                    Current RTOTOHubId :\n                  ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                    Change RTOToHubId To :\n                  ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                    Reason :\n                  ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Change RTOToHubId")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v("File Upload")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Upload File ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit",
      "id": "uploadRTO"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Upload & Update")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Update Address Using ShippingID")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Shipment ID : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                    Shipping address:\n                  ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                    Shipping State:\n                  ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                    Shipping City\n                  ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                    Mobile No :\n                  ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                    Shipping Pincode :\n                  ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                    IsRedirected(Bank) :\n                  ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                    soID Pin :\n                  ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                    Reason :\n                  ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Update ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Update Address In Bulk")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("IsRedirected(Bank) : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Upload File: ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit",
      "name": "uploadFile",
      "id": "uploadFile"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Upload & Update")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1048bec0","hasScoped":true}!./src/views/components/ChangeRTOandShipmentDetails/ChangeRTOandShipmentDetails.component.html
// module id = 1022
// module chunks = 1